import React, { useRef, useState, useLayoutEffect, useImperativeHandle, forwardRef } from 'react';
import ReactDOM from 'react-dom';
// @ts-expect-error — ?shadow query returns a string via css-loader exportType:'string'
import tailwindCSS from 'App/styles/tailwind.css?shadow';

type Props = React.HTMLAttributes<HTMLDivElement> & {
	children: React.ReactNode;
};

/**
 * Renders children inside a Shadow DOM boundary.
 * All legacy CSS is blocked; only Tailwind/shadcn styles apply inside.
 */
const ShadcnScope = forwardRef<HTMLDivElement, Props>(({ children, ...divProps }, ref) => {
	const hostRef = useRef<HTMLDivElement>(null);
	const [container, setContainer] = useState<HTMLDivElement | null>(null);

	useImperativeHandle(ref, () => hostRef.current as HTMLDivElement);

	useLayoutEffect(() => {
		const host = hostRef.current;
		if (!host || host.shadowRoot) return;

		const shadow = host.attachShadow({ mode: 'open' });

		const style = document.createElement('style');
		style.textContent = tailwindCSS;
		shadow.appendChild(style);

		const root = document.createElement('div');
		root.style.display = 'contents';
		shadow.appendChild(root);

		setContainer(root);
	}, []);

	return (
		<div ref={hostRef} {...divProps}>
			{container && ReactDOM.createPortal(children, container)}
		</div>
	);
});

ShadcnScope.displayName = 'ShadcnScope';

export default ShadcnScope;
